import type { StyleRule } from '@archipro-design/aria';
import {
    pxToRem,
    pxArrayToRem,
    gridClassName,
    paginationItemCounterClassName,
    paginationSlotClassNames,
} from '@archipro-design/aria';

const columnTemplateDynamic = (column: number, gapX: number) =>
    `repeat(${column},calc(${100 / column}% - ${
        (gapX * (column - 1)) / column
    }rem))`;

export const Wrap: StyleRule = ({ theme }) => ({
    paddingTop: 0,
    borderTop: `1px solid ${theme.siteVariables.colors.transparency.white['30%']}`,

    [theme.screen.laptop]: {
        borderTop: 'none',
    },
});
export const Container: StyleRule = ({ theme }) => ({
    gridGap: pxToRem(32),
    [theme.screen.laptop]: {
        gridGap: pxToRem(50),
    },
});
export const FilterSection: StyleRule = ({ theme }) => ({
    borderTop: `2px solid ${theme.siteVariables.colorScheme.default?.border}`,
    paddingTop: pxToRem(12),
});
export const ResultSection: StyleRule = ({ theme }) => ({
    [`& > div`]: {
        padding: 0,

        [`& > .${gridClassName}`]: {
            gridGap: pxArrayToRem([48, 6]),
            gridTemplateColumns: columnTemplateDynamic(2, 6),

            [theme.screen.laptop]: {
                gridGap: pxArrayToRem([130, 28]),
                gridTemplateColumns: columnTemplateDynamic(4, 28),
            },
        },

        [`& .${paginationItemCounterClassName}`]: {
            color: theme.siteVariables.colorScheme.default?.foregroundDisabled,
        },

        [`& .${paginationSlotClassNames.list}`]: {
            [theme.screen.laptop]: {
                marginBottom: pxToRem(24),
            },
        },
    },
});
